import React, { useEffect, useState } from "react";
import {
  Alert,
  AlertIcon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalHeader,
  ModalCloseButton,
  Button,
  Spinner,
  Text,
  Box,
  Stack
} from "@chakra-ui/core";
import { UPDATE_TRANSACTION } from "../../graphql/mutations";
import { useMutation } from "react-apollo";
import { FaQuestionCircle } from "react-icons/fa"

const CancelLink = ({ order, setIsCancelLink, isCancelLink, refetch }) => {
  const [updateTransaction] = useMutation(UPDATE_TRANSACTION);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isError, setIsError] = useState("");
  const [isConfirmCancel, setIsConfirmCancel] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleClose = () => {
    refetch();
    setIsCancelLink(false);
    setIsProcessing(false);
    setIsError("");
    setIsConfirmCancel(false)
    setIsSuccess(false)
  };
  useEffect(() => {
    if (isCancelLink && isConfirmCancel) {
      setIsProcessing(true);
      updateTransaction({
        variables: {
          input: { transactionRef: order.ref, status: "cancelled" },
        },
      })
        .then(() => {
          setIsProcessing(false);
          setIsSuccess(true)
        })
        .catch((err) => {
          //const errorStack = err.message.split(":");
          //console.log(err);
          setIsProcessing(false);
          setIsError("Something went wrong, please try again later");
        });
      // setIsProcessing(false)
      // setIsError("")
    }
  }, [isCancelLink, isConfirmCancel, order, updateTransaction, refetch]);

  return (
    <>
      <Modal isOpen={isCancelLink} onClose={handleClose}>
        <ModalOverlay />
        <ModalContent color="primary.500">
          <ModalHeader fontWeight="bold">
            {!isConfirmCancel && "Confirmation"}
            {isError && "Error"}
            {isSuccess && "Success"}
            {isProcessing && "Processing"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {
              isConfirmCancel ? (
                <Alert bg="none" status={isError ? "error" : "success"}>
                {isError && <AlertIcon color="danger.400" />}
                {isSuccess && <AlertIcon color="success.500" />}
                {isProcessing && <Spinner mx={4} color="success.500" />}
  
                {isError && "Something went wrong, please try again later"}
                {isSuccess && "Your cancellation request has been processed successfully."}
                {isProcessing && "Processing your request"}
              </Alert>
  
              ) : (
                <Stack isInline>
                <Box as={FaQuestionCircle} size="24px" color="danger.300" />
                <Text>Are you sure you want to cancel this link ?</Text>
                </Stack>
              )
            }
          </ModalBody>

          <ModalFooter>
            {
              !isConfirmCancel &&
              <Button mx={4} variant="ghost" color="danger.300" onClick={()=>setIsConfirmCancel(true)}>Confirm</Button>  
            }
            <Button onClick={handleClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CancelLink;
